import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { useLang } from "../../i18n/LangContext";

export const startGoogleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/espace";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { signIn, signOut } = useAuth();
  const { t } = useLang();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    api.post("/auth/google", { session_id: sessionId })
      .then(({ data }) => {
        signIn(data);
        navigate(data.user.role === "admin" ? "/admin" : "/espace", { replace: true });
      })
      .catch(() => {
        signOut();
        toast.error(t.auth.googleFailed);
        navigate("/espace", { replace: true });
      });
  }, [navigate, signIn, signOut, t]);

  return <div className="login-wrap" data-testid="auth-callback"><Loader2 className="spin" aria-label="Loading" /></div>;
};
